module.exports = __webpack_public_path__ + "static/media/person-production.e1c10b74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/whoCanBFromElla/person-production.svg
// module id = 137
// module chunks = 0